import React, {useContext} from 'react';
import FormContext from "formContext";
import axios from 'axios';
import GetRouteByName from 'getRouteByName';
import { pushCandidateEvent } from "dataLayerHelper";

const useRegisterSubmitHandler = () => {
  const {formData, handleErrors, currentStep, renderStep, setErrors, setLoading} = useContext(FormContext);
  const registerConfirmationUrl = GetRouteByName('register-confirmation').url;

  const handleRegisterSubmit = () => {
    setErrors();
    setLoading(true);

    // Fetch saved jobs.
    const favoriteJobs = JSON.parse(localStorage.getItem("favJobs"));
    if (favoriteJobs && formData[currentStep]) {
      formData[currentStep].savedJobs = favoriteJobs;
    }

    if (formData[currentStep] && captcha?.getToken('mrnd_captcha')) {
      formData[currentStep].captchaToken = captcha?.getToken('mrnd_captcha');
    }

    let data = formData[currentStep];
    if (currentStep === 1) {
      data= Object.assign(formData[currentStep], formData[0]);
    }
    axios.post(`${process.env.REACT_APP_API_PREFIX}/signup?step=${currentStep+1}`, data)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          if (currentStep === 0) {
            renderStep('next');
            setLoading(false);
          }
          else {
            pushCandidateEvent("register");
            window.location = registerConfirmationUrl;
            setLoading(false);
          }
          captcha?.reset('mrnd_captcha');
        }
      })
      .catch(error => {
        handleErrors(error.response.data);
        setLoading(false);
        captcha?.reset('mrnd_captcha');
      });
  }

  return {
    handleRegisterSubmit
  }
};

export default useRegisterSubmitHandler;
